import { z } from 'zod';
export const SOCIAL_PLATFORMS = [
    'twitter',
    'linkedin',
    'instagram',
    'facebook',
    'threads',
    'tiktok',
    'youtube',
];
/** POST /api/transcriptions/:id/titles */
export const suggestTitlesSchema = z.object({
    episodeId: z.string().uuid().optional(),
    count: z.number().int().min(1).max(10).optional(),
});
/** POST /api/transcriptions/:id/social-posts */
export const socialPostsSchema = z.object({
    platforms: z.array(z.enum(SOCIAL_PLATFORMS)).min(1).max(SOCIAL_PLATFORMS.length).optional(),
});
//# sourceMappingURL=transcription.schemas.js.map